import { cn } from "@/utils/cn";

/**
 * Uses the `skeleton-pulse` animation defined in tailwind.config.ts (which
 * cycles `--muted` → `--border`), not shadcn's default `animate-pulse
 * bg-primary/10` — docs/ui/design-system.md §15 is explicit the skeleton
 * pulse is a neutral two-tone cycle, not a brand-tinted one.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-skeleton-pulse rounded-sm bg-muted", className)} {...props} />;
}

export { Skeleton };
